import { render, staticRenderFns } from "./CupBoardShopManage.vue?vue&type=template&id=8772120e&scoped=true"
import script from "./CupBoardShopManage.vue?vue&type=script&lang=js"
export * from "./CupBoardShopManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8772120e",
  null
  
)

export default component.exports